/** Naslov i opis ispod scene; naslov ovisi o tome je li trošak nov. */
export const EXPENSE_INTRO_TEXTS = {
  create: {
    title: "Zabilježite trošak vozila",
    description: "Odaberite vrstu troška, upišite iznos i priložite račun. Trošak odmah ulazi u pregled troškova vozila.",
  },
  edit: {
    title: "Uredite trošak vozila",
    description: "Ispravite iznos, datume ili priloge. Promjena se odmah vidi u pregledu troškova vozila.",
  },
};

/** Naslov i opis za korake nakon prvog; prvi korak koristi tekst za unos ili uređivanje. */
export const EXPENSE_INTRO_STEP_TEXTS: Record<number, { title: string; description: string }> = {
  1: {
    title: "Koliko je trošak iznosio?",
    description: "Upišite naziv, datume i iznos. Porez se računa sam iz iznosa.",
  },
  2: {
    title: "Priložite račun",
    description: "Račun ili drugi dokument ostaje uz trošak, pa se uvijek može provjeriti.",
  },
};

/** Primjeri dok korisnik ništa nije upisao. */
export const EXPENSE_INTRO_SAMPLE = {
  typeName: "Servis",
  typeCode: "FLEET-SERVIS",
  name: "Mali servis 60.000 km",
  amount: 180,
  taxAmount: 45,
  files: ["Racun_2291.pdf", "Radni_nalog.pdf"],
};
